export default {
  en: {
    snack: {
      generic_error: 'Something went wrong',
      block_success: 'Member successfully blocked',
      unblock_success: 'Member successfully unblocked',
      remove_success: 'Member successfully removed',
      set_as_contact_person: {
        on_success: 'Successfully removed contact person',
        off_success: 'Member successfully set as contact person',
      },
    },
    confirm_dialog_msg: {
      default: 'Are you sure?',
    },
    actions: {
      block: 'Block',
      unblock: 'Unblock',
      contact: 'Contact',
      edit_rights: 'Edit rights',
      remove: 'Remove member',
      set_as_contact_person: {
        on: 'Remove as contact person',
        off: 'Set as contact person',
      },
    },
  },
};
